import { IEventrTransport } from '@eventr/common'
import { ObjectProvider } from './providers/objectProvider'
import { BaseCard } from './subComponents/baseCard'
import { TransportHeader } from './transportComponents/transportHeader'
import { TransportInfo } from './transportComponents/transportInfo'
import { TransportTimes } from './transportComponents/transportTimes'

interface TransportCardProps {
    id?: string
    data: IEventrTransport
    past?: boolean
    border?: boolean
}

export const TransportCard = ({
    id,
    data,
    past = false,
}: TransportCardProps) => {
    return (
        <ObjectProvider past={past} _id={data._id} sectionID={'5'}>
            <BaseCard id={id} past={past}>
                <TransportHeader
                    transport_alias={data.transport_alias}
                    label={data.label}
                    labelTime={data.labelTime}
                    pick_up={data.pick_up}
                    transport_type={data.transport_type}
                    visibility={data.visibility}
                />
                {data.label && (
                    <TransportTimes
                        pick_up={data.pick_up}
                        drop_off={data.drop_off}
                        pick_up_location={data.pick_up_location}
                        drop_off_location={data.drop_off_location}
                        pick_up_stop={data['pick-up_stop']}
                        drop_off_stop={data['drop-off_stop']}
                    />
                )}
                <TransportInfo
                    pick_up={data.pick_up}
                    drop_off={data.drop_off}
                    booking_ref={data.booking_ref}
                    documents={data.documents}
                    additional_info={data.additional_information}
                    passengers_list={data.passengers_list}
                    pick_up_location={data.pick_up_location}
                    drop_off_location={data.drop_off_location}
                    chatNames={[data.transport_alias]}
                />
            </BaseCard>
        </ObjectProvider>
    )
}
